import React, { useRef } from 'react';
import { Header, LoadingContainer, NoData, Title } from './ChartsList.styles';
import {
	ApButtonIcon,
	ApLoaderDefault,
	ApLoaderText,
	ApMenu,
	ApMenuItem,
} from '@alixpartners/ui-components';
import { EXPORT_OPTIONS } from 'CategoryManagement/utils';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsHeatmap from 'highcharts/modules/heatmap';
import { useCommonSuppliersContext } from 'contexts/CategoryInsightsKpi/CommonSupplierProvider';
import Pagination from 'components/Pagination/Pagination';
HighchartsHeatmap(Highcharts);

const CommonSupplierByBU = ({ chartTitle }) => {
	const {
		isLoading,
		data,
		options,
		currentPage,
		setCurrentPage,
		pageSize,
	} = useCommonSuppliersContext();

	const chartRef = useRef();
	const getChartInstance = () => {
		return chartRef && chartRef.current && chartRef.current.chart;
	};

	const handleChartExport = option => {
		const chartInstance = getChartInstance();
		if (chartInstance && option.value === 'png') {
			chartInstance.exportChart(
				{
					filename: chartTitle,
				},
				{
					title: {
						text: chartTitle,
						align: 'left',
						style: {
							fontSize: '16px',
							fontWeight: 'bold',
							fontFamily: 'Roboto',
						},
					},

					chart: { width: 1200 },
				}
			);
		}
		if (option.value === 'xlsx') {
			this.handleChartDataExport();
		}
	};
	return (
		// <SectionWrapper>
		<>
			<Header>
				<Title>{chartTitle}</Title>
				<ApMenu button={<ApButtonIcon iconName="download" />}>
					{EXPORT_OPTIONS.map(option => (
						<ApMenuItem
							key={option.value}
							onClick={() => handleChartExport(option)}
						>
							{option.label}
						</ApMenuItem>
					))}
				</ApMenu>
			</Header>
			{isLoading ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{data.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<HighchartsReact
							highcharts={Highcharts}
							options={options}
							ref={chartRef}
						/>
					)}
				</>
			)}
			{!isLoading && (
				<>
					<Pagination
						currentPage={currentPage}
						totalCount={options.transformDataLength || 0}
						pageSize={pageSize}
						onPageChange={page => setCurrentPage(page)}
						position="center"
					/>
				</>
			)}
		</>
		// </SectionWrapper>
	);
};

export default CommonSupplierByBU;
